import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { AuthService } from 'angularx-social-login';
import { SessionHandler } from './session-handler.service';
import { MatDialog } from '@angular/material/dialog';
import { LoaderService } from '../../loader/loader.service';
import { dialogComponent } from '../../dialog/dialog.component';
import { Router } from '@angular/router';
import { APPCONFIG } from '../../config';

declare const gapi: any;

@Injectable()
export class HttpService {
  AppConfig: any;
  public url = APPCONFIG.appUrl;
  id_token: string;
  public dialogRef: any;
  public headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'apiKey': 'AIzaSyDnTiD1XwEfvVYZCk6I_i5M59lDKZpqH6o',
    'Access-Control-Allow-Origin': '*',
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache'
  });

  constructor(
    private http: HttpClient,
    private router: Router,
    private LoaderService: LoaderService,
    private dialog: MatDialog,
    public sessionHandler: SessionHandler,
    private authService: AuthService
  ) {
    this.authService.authState.subscribe((user) => {
      if (user != null) this.id_token="eyJhbGciOiJSUzI1NiIsImtpZCI6IjhlOGZjOGU1NTZmN2E3NmQwOGQzNTgyOWQ2ZjkwYWUyZTEyY2ZkMGQiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJhY2NvdW50cy5nb29nbGUuY29tIiwiYXpwIjoiNjUxMjUwNjI3OTY2LTlhNTNnaWw3M3Rjb29ubDBjNGZmam9icnUwMW10YnRwLmFwcHMuZ29vZ2xldXNlcmNvbnRlbnQuY29tIiwiYXVkIjoiNjUxMjUwNjI3OTY2LTlhNTNnaWw3M3Rjb29ubDBjNGZmam9icnUwMW10YnRwLmFwcHMuZ29vZ2xldXNlcmNvbnRlbnQuY29tIiwic3ViIjoiMTA0OTU3MDY3MjU5MTQ5MDQ1Nzc3IiwiaGQiOiJwZXJzaXN0ZW50LmNvbSIsImVtYWlsIjoibmVoYV90aXdhcmlAcGVyc2lzdGVudC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiYXRfaGFzaCI6ImtNQm9rSUt4Q2psS3dneVFGZ1k4blEiLCJuYmYiOjE3NTIwNDE0OTYsIm5hbWUiOiJOZWhhIFRpd2FyaSIsInBpY3R1cmUiOiJodHRwczovL2xoMy5nb29nbGV1c2VyY29udGVudC5jb20vYS9BQ2c4b2NKQ2tRdFFZdDVsYVJKX190T0tZdE1aWjRBUmhEU25ZYndtREFpOEs3M0VmTkE1SUE9czk2LWMiLCJnaXZlbl9uYW1lIjoiTmVoYSIsImZhbWlseV9uYW1lIjoiVGl3YXJpIiwiaWF0IjoxNzUyMDQxNzk2LCJleHAiOjE3NTIwNDUzOTYsImp0aSI6Ijg5N2M3NGE1YzU2NDBhYjYwNTU5MWMzZDZlNmIwNTkwMGI0OWFlNWQifQ.hapEWpqBaoOq_muDuhKJbBdVt2KDKESZ4W27pyrFV70w2xrRvMlfTuHz6j2Zu_fp8qW4Bl6GQYplQ8TlR37MOQHu5-Q1_CUpkWKL_jTxoyVasZKNjZMUjlVMQJ3hGCHJPllvlSqES-G3jLp15fRcq55n8X7qSm5aMCPEKNq7BoOLW8NgzToUGZSW06xHs_ndWSrPfVy9D30rSZUC9n8MptYYOMR9_AYxcsmUh41Yv2X9VW9N2GL-y3rLpTqYtmfLJtCxPuUuv6YJnv-0Z-pwTKCaMOt8g_K65P8v2uFY2i6u59We75YsgD49RkkO69dpwvpXRryIGYLuuRXVnBTALA";
    });
  }

  getRequest(url): Observable<any[]> {
    const headers = this.addAccessToken(this.headers);
    this.sessionHandler.saveItem("timestamp", Math.round(new Date().getTime() / 1000.0));
    this.showLoader();
    return this.http.get<any[]>(`${this.url}/${url}`, { headers }).pipe(
      map(res => this.errorCheckFunction(res, 'api')),
      catchError(error => throwError(() => this.handleError(error, 'api') || 'Server error'))
    );
  }

  getRequestWithHeader(url, header): Observable<any[]> {
    const headers = this.addAccessToken(header);
    console.log("access token ", headers)
    this.sessionHandler.saveItem("timestamp", Math.round(new Date().getTime() / 1000.0));
    this.showLoader();
    return this.http.get<any[]>(`${this.url}/${url}`, { headers }).pipe(
      map(res => this.errorCheckFunction(res, 'api')),
      catchError(error => throwError(() => this.handleError(error, 'api') || 'Server error'))
    );
  }

  getRequestWithHeaderTest(url, header): Observable<any[]> {
    const headers = this.addAccessToken(header);
    this.sessionHandler.saveItem("timestamp", Math.round(new Date().getTime() / 1000.0));
    this.showLoader();
    return this.http.get<any[]>(url, { headers }).pipe(
      map(res => this.errorCheckFunction(res, 'api')),
      catchError(error => throwError(() => this.handleError(error, 'api') || 'Server error'))
    );
  }

  getRequestWithoutLoader(url): Observable<any[]> {
    const headers = this.addAccessToken(this.headers);
    this.sessionHandler.saveItem("timestamp", Math.round(new Date().getTime() / 1000.0));
    return this.http.get<any[]>(`${this.url}/${url}`, { headers }).pipe(
      map(res => this.errorCheckFunction(res, 'api')),
      catchError(error => throwError(() => this.handleError(error, 'api') || 'Server error'))
    );
  }

  postRequest(body: Object, api: string): Observable<any[]> {
    this.sessionHandler.saveItem("timestamp", Math.round(new Date().getTime() / 1000.0));
    this.showLoader();
    const bodyString = JSON.stringify(body);
    let headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' });
    headers = this.addAccessToken(headers);

    return this.http.post<any[]>(`${this.url}/${api}`, bodyString, { headers }).pipe(
      map(res => this.errorCheckFunction(res, api)),
      catchError(error => throwError(() => this.handleError(error, api) || 'Server error'))
    );
  }

  postRequestWithHeader(body: Object, api: string, header): Observable<any[]> {
    const headers = this.addAccessToken(header);
    this.sessionHandler.saveItem("timestamp", Math.round(new Date().getTime() / 1000.0));
    this.showLoader();
    const bodyString = JSON.stringify(body);

    return this.http.post<any[]>(`${this.url}/${api}`, body, { headers }).pipe(
      map(res => this.errorCheckFunction(res, api)),
      catchError(error => throwError(() => this.handleError(error, api) || 'Server error'))
    );
  }

  checkSession(): boolean {
    const userEmail = localStorage.getItem('userEmail');
    const user = localStorage.getItem('user');
    return !(userEmail == null || userEmail === "" || user == null || user === "");
  }

  ngOnInit() {
    this.AppConfig = APPCONFIG;
  }

  showSessionError(): void {
    // this.router.navigateByUrl('/extra/login');
  }

  onEnd(): void {
    this.hideLoader();
  }

  showLoader(): void {
    this.LoaderService.show();
  }

  hideLoader(): void {
    this.LoaderService.hide();
  }

  handleError(e: any, api: string): boolean {
    console.log(e);
    const errorJson = e;
    if (errorJson.error && api !== 'userOperationsApi/v1/login') {
      this.dialogRef = this.dialog.open(dialogComponent, { disableClose: true });
      this.dialogRef.componentInstance.msg = errorJson.error.errors?.[0]?.message || 'Unknown Error';
    }
    if (errorJson.error && api === 'userOperationsApi/v1/login') {
      alert(errorJson.error.message);
    }
    if (errorJson.error) {
      alert("Error in HTTP request");
    }
    this.hideLoader();
    return false;
  }

  errorCheckFunction(jsonResult: any, api: string): any {
    if (jsonResult === -401) {
      window.location.reload();
    }
    return jsonResult;
  }

  private addAccessToken(header: any): HttpHeaders {
    let httpHeaders: HttpHeaders;

    // Support both { headers: HttpHeaders } and HttpHeaders directly
    if (header && header.headers instanceof HttpHeaders) {
        httpHeaders = header.headers;
    } else if (header instanceof HttpHeaders) {
        httpHeaders = header;
    } else {
        httpHeaders = new HttpHeaders();
    }

    // Only set Authorization if not already present
    if (!httpHeaders.has('Authorization') && this.id_token) {
        httpHeaders = httpHeaders.set('Authorization', `Bearer ${this.id_token}`);
    }
    return httpHeaders;
}


//   private addAccessToken(header:any){
//     if((header as any).headers != undefined){
//         (header as any).headers.set('authtoken',this.id_token);
//     }
    
//     return header;
// }
}
